<div id="new-representative-wrapper" data-cy="new-representative-wrapper">
  <div id="go-back-representatives-wrapper">
    <p-button
      (onClick)="goBackToRepresentativesTable()"
      [style]="{ height: '100%' }"
      id="go-back-new-representative"
      data-cy="go-back-representative-button"
    >
      <i class="fa-solid fa-arrow-left fa-xl" style="color: #213246"></i>
    </p-button>
  </div>
  <p-card class="representative-form-card" data-cy="representative-form-card">
    <ng-template pTemplate="header">
      <div id="representative-form-card-header">
        <h1>New Representative</h1>
      </div>
    </ng-template>
    <app-representative-form></app-representative-form>
    <ng-template pTemplate="footer">
      <div id="representative-form-card-footer">
        <p-button
          (onClick)="saveRepresentative()"
          [style]="{ height: '100%' }"
          [disabled]="(isSaveDisabled$ | async) === true || isSaving"
          [loading]="isSaving"
          size="large"
          id="save-new-representative"
          data-cy="save-representative-button"
        >
          Save
        </p-button>
      </div>
    </ng-template>
  </p-card>
</div>
